import { takeEvery, put, call, all, SagaReturnType } from 'redux-saga/effects';
import { patientAction } from '../../actions/constant';
import patientService from 'src/services/apiServices/patientServices';

const {
  GET_THERAPIST_DISCIPLINE_FAILURE,
  GET_THERAPIST_DISCIPLINE_SUCCESS,
  GET_THERAPIST_DISCIPLINE_REQUEST,
  GET_THERAPIST_DISCIPLINE_LOADING,
} = patientAction;

function* getAllTherapistDiscipline(): SagaReturnType<any> {
  yield put({ type: GET_THERAPIST_DISCIPLINE_LOADING });
  try {
    const response = yield all(
      ['OT', 'PT', 'SLP'].map((params) =>
        call(patientService.getTherapistDisciplinePatient, { discipline: params })
      )
    );
    let otResponse, ptResponse, slpResponse;
    [otResponse, ptResponse, slpResponse] = response;

    yield put({
      type: GET_THERAPIST_DISCIPLINE_SUCCESS,
      payload: {
        otResponse: otResponse?.status === 200 ? otResponse?.data?.data : null,
        ptResponse: ptResponse?.status === 200 ? ptResponse?.data?.data : null,
        slpResponse: slpResponse?.status === 200 ? slpResponse?.data?.data : null,
      },
    });
  } catch (error) {
    yield put({ type: GET_THERAPIST_DISCIPLINE_FAILURE, payload: error });
  }
}

function* getAllTherapistDisciplineSaga() {
  yield takeEvery(GET_THERAPIST_DISCIPLINE_REQUEST, getAllTherapistDiscipline);
}

export default getAllTherapistDisciplineSaga;
